<template>
 <div>
     <div v-if="product_info" class="margin-top-50 pretty-banner">
        <h5 style="font-size:18px;">Same product but different variations</h5>
        <p >if this product has different colours, sizes, etc... no need filling this long form again, go to this product view and set them.</p>
        <p class="center"><i class="fa fa-arrow-right"></i><a :href="product_url">Proceed to this Product's View </a></p>
     </div>
    <div v-if="!product_info" class="col-sm-10 col-sm-offset-4">
       
        <h6>Add Product / Service</h6>
            <form>
                <ul class="row">
                 
                    <li class="col-sm-12">
                        <label> *Product Name
                            <input type="text" v-model="product.product_name" value="" placeholder="">
                        </label>
                    </li>
                    
                   <li class="col-md-12" v-if="sellpoint_categories.length != 0">
                        <label> Select Product Category
                        <select v-model="product.product_category" id="category-type-1" v-on:change="trackevent('category-type-1')">
                            <option value="0" :disabled="category_type_1">Select</option>
                            <option :disabled="category_type_1" v-for="category in sellpoint_categories" :key="category.business_category_id" :value="category.business_category_id">{{category.business_category}}</option>
                        </select>
                        </label>
                    </li>
                    <li class="col-sm-4 col-sm-offset-4" v-if="sellpoint_categories.length != 0">
                        <label><b> *Or </b></label>
                    </li>
                    <li class="col-md-12">
                        <label>Select from related Shop Categories
                        <select v-model="product.product_sub_category" class="category-type-2" v-on:change="trackevent('category-type-2')">
                            <option value="0" :disabled="category_type_2">Select</option>
                            <option :disabled="category_type_2" v-for="category in sub_categories" :key="category.sub_category_id" :value="category.sub_category_id">{{category.sub_category_name}}</option>
                        </select>
                        </label>
                    </li>
                   
                    <li class="col-md-12">
                          <label> <b> *Or </b> Enter a specific Category
                            <input :disabled="category_type_3" type="text" v-model="product.product_listed_category" placeholder="" id="category-type-3" v-on:change="trackevent('category-type-3')">
                          </label>
                    </li>
                    <li class="col-md-12">
                          <label> *Product Description
                            <textarea  v-model="product.product_description"></textarea>
                          </label>
                    </li>
                    <!-- <h6>Add a product Item, you can add more items later</h6> -->
                    
                    <li class="col-md-12">
                          <label> *Product Price
                            <input type="number" v-model="product.product_item_price" placeholder="" required>
                          </label>
                    </li>

                    <li class="col-md-12">
                          <label> *Product Weight
                            <input type="number" v-model="product.product_item_weight"  step="any" placeholder="" required>
                          </label>
                    </li>

                     <li class="col-md-12">
                          <label> *Product Quantity
                            <input type="number" v-model="product.product_item_quantity"  placeholder="" required>
                          </label>
                    </li>
                    
                    <li class="col-md-12">
                        <div class="upload-btn-wrapper" style="cursor:pointer">
                             <!-- <img class="img_responsive"/> -->
                            <button class="upload-btn">Add Product Image</button>
                            <input type="file" id="input-file" @change="onFileChange($event)" accept="image/*"/>
                            <span v-if="file_info[0]"><b>Added {{file_info[0].name}}</b></span>                                                                                                                                                                                                                                                                                                                                        
                        </div>
                    </li>
                    <li class="col-md-6">
                          <button type="button" class="btn" @click="addProduct">Add</button>
                    </li>
                </ul>
        </form>
    </div>
</div>
</template>
<style>
.pretty-banner{
   border: 1px solid #b3b9c0;
   padding: 1.2em;
   background: #83ee91;
   line-height: 1.8;
   border-radius: 5px;
   color:#fff; 
}
.pretty-banner p a:hover{
    color: #ff0000;
}
  /*form*/
  .contact_form li {
	text-align: left;
	margin-bottom: 10px;
}
.contact_form li input {
	display: inline-block;
	width: 100%;
	height: 35px;
	padding: 0 10px;
	margin-top: 5px;
}
.contact_form li .error {
	border: 1px solid #CCC;
	border-bottom: 1px solid red;
}
.contact_form li .form-control {
	height: 45px;
	border: 1px solid #2d3a4b;
	box-shadow: none;
	border-radius: 0px;
	background: #fff;
}
.contact_form li textarea {
	height: 140px !important;
	width: 340px;
	margin-top: 10px;
}
.contact_form li .btn {
	text-transform: uppercase;
	padding: 0px 40px;
	height: 45px;
	line-height: 45px;
	font-size: 14px;
	margin-top: 15px;
}
.contact_form li .btn:hover {
	background: #ffe115;
}
.contact-form .tittle {
	text-align: center;
}
.contact-form .tittle hr {
	width: 28px;
	height: 5px;
	margin: 15px auto;
	background: #448aff;
	border: none;
}
.contact-form .tittle p {
	text-transform: none;
	font-size: 16px;
}
.contact-form label {
	font-weight: normal;
	color: #2d3a4b;
	font-size: 12px;
	text-transform: uppercase;
	display: inline-block;
	width: 100%;
	margin: 0px;
	margin-bottom: 13px;
}
.contact-form textarea {
	display: inline-block;
	width: 100%;
	position: relative;
	padding: 10px 20px;
}

</style>

<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'ProductForm',
    data () {
        return {
            user:{},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            product:{},
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {}
        }
    },
    components: {
       
     },
    methods: {
        setComponent(attr1,attr2){
            this.setPanel = true;
            if(attr1 == 'create-sellpoint'){
                this.createSellpointPanel= true;
                this.addProductPanel = false;
                this.addProductItemPanel = false;
            }
            if(attr1 == 'add-product'){
                this.addProductPanel = true;
                this.addProductItemPanel = false;
                this.createSellpointPanel= false;
            }
            if(attr1 == 'add-product-item'){
                this.addProductItemPanel = true;
                this.addProductPanel = false;
                this.createSellpointPanel= false;

            }
        },
        
        trackevent(e){
            // $('#category-type-3').disabled = true;
            if(e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined){
              this.category_type_2 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined){
              this.category_type_1 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined){
              this.category_type_1 = true;
              this.category_type_2 = true; 
            }
            else{
            this.category_type_1 = false;
              this.category_type_2 = false;
              this.category_type_3 = false;
             }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        //get sellpoint categories
                        this.getSellpointCategories();

                    }else {
                        //this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        //this.$router.push('login');
                    }
                })
            }else {
                //this.$router.push('login');
            }
        },

        getSellpointCategories(){
            service.getBusinessByUserName(this, this.$route.params.id).then(response => {
                if(response.body.status == 200) {
                   this.sellpoint = response.body.data;
                   //let sellpoint_data = response.body.data;
                    service.getBusinessCategories(this, this.sellpoint.business_id).then(response => {
                        if(response.body.status == 200) {
                            this.sellpoint_categories = response.body.data;
                        }
                    }).catch((err) => {})
                    this.getSubCategories(this.sellpoint.business_category_id);
                }
            }).catch((err) => {
                //log it
               // this.$router.push("/")
               console.log(err)
            })

        },

        getSubCategories(category){
            service.getBusinessSubCategories(this, category).then(response => {
                if(response.body.status == 200) {
                    this.sub_categories = response.body.data;
                }
            }).catch((err) => {})
                
        },

        addProduct(){
            this.disable_btn = true;
            //this.business.agree = true;
            var credentials = {
                product_name: this.product.product_name,
                product_category: this.product.product_category || 0,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            }
            
            let navi = this.$router;
            if(credentials.product_name != undefined) {
                service.addProduct(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        toastr.success("Product Added Successfully", 'Success!');
                        //log user in
                        this.product = data.body.data;
                        
                        //add image
                        //let result = data.body.data;
                        this.imageForm.append("data_id", this.product.product_item_id);
                        this.imageForm.append("data_type","product_items");
                        service.uploadDataPhoto(this, this.imageForm).then(data => {
                        if(data.body.status == 200){
                            //this.product.product_image = data.body.data;
                            // location.reload(true);
                            this.product_info = true;
                            this.product_url = "/"+this.$route.params.id+"/"+this.product.product_url_name;
                        }
                        }).catch((err) => {
                                if(err) {
                                // log it
                                }
                            toastr.warning("Something went wrong.", 'Warning!');
                        })

                        //navi.push("/"+this.$route.params.id+"/"+this.product.product_url_name); //changed for now, info on banner

                        
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.warning("Something went wrong", 'Warning!'); 
                       // console.log(err)
                        this.disable_btn = false;
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },

    // addProductItem(){
    //     this.disable_btn = true;
    //     //this.business.agree = true;
    //     var credentials = {
    //         product_id: this.product.product_id,
    //         product_price: this.product_item.product_item_price,
    //     }

    //     let navi = this.$router;
    //    if(credentials.product_price != undefined) {
    //         service.addProductItem(this, credentials).then(function(data) {
    //             if(data.body.status == 201) {
    //                 toastr.success("Product Item Added Successfully", 'Success!');
    //                 //log user in
    //                 this.setComponent('add-product-item','');
    //             }
    //         }).catch((err) => {
    //             if(err) {
    //                 toastr.warning("Something went wrong", 'Warning!'); 
    //                 //console.log(err)
    //                 this.disable_btn = false;
    //             }
    //         })
    //     }else {
    //         toastr.error('Kindly fill all fields', 'Warning!');
    //         this.disable_btn = false;
    //     }
    // },

    //uploads
    onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (files.length)
        {   
            this.file_info = files;
            let formData = new FormData();
            formData.append('photo', files[0]); 
            this.imageForm = formData;
        }   
       
    },

},
    created: function(){
        this.preset();
    }
}

</script>


// WEBPACK FOOTER //
// src/components/product/ProductForm.vue